
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import WrapTextIcon from "@mui/icons-material/WrapText";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import CarpenterIcon from "@mui/icons-material/Carpenter";

export interface MenuItemOption {
  icon: JSX.Element;
  text: string;
}

export const contextualMenuItems: MenuItemOption[] = [
  { icon: <WorkOutlineIcon />, text: "Formalizar" },
  { icon: <ArticleOutlinedIcon />, text: "Elaborar" },
  { icon: <EditNoteIcon />, text: "Mejorar redacción" },
  { icon: <BeachAccessOutlinedIcon />, text: "Mas casual" },
  { icon: <WrapTextIcon />, text: "Resumir" },
  { icon: <TipsAndUpdatesIcon />, text: "Generar idea" },
  { icon: <CarpenterIcon />, text: "Acortar" },
];
